var ProductMain = {

  methods: {
    
    fixProductName: function(){
      	setTimeout(() => {
			let prodName = $('.e-product__infos--name-product').text().replace(' - default title', '').replace(/ā/gm,'ã');
      		$('.e-product__infos--name-product').text(prodName);
		},200);
    },
  
    howToUseDinamic: function () {
      $('.e-modal-how-to-use__content').html($('.e-description-how-to-use div').html())
      $('.e-description-how-to-use div').remove();
    },

    socialMedia: function () {
      var url_product = window.location.href;

      $('.e-product__share--icons-btn').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('e-active');
        $('.e-product__share--icons ul').toggleClass('e-active');
      });

      $('.e-product__share--icons ul li .e-icon-twitter').on('click', function (e) {
        e.preventDefault();
        var url_shared_twitter = 'https://twitter.com/share?text=CONDICIONADOR%20SOLIDO&url=';
        window.open(url_shared_twitter + url_product);
      });

      $('.e-product__share--icons ul li .e-icon-facebook').on('click', function (e) {
        e.preventDefault();
        var url_shared_facebook = 'https://www.facebook.com/sharer.php?u=';
        window.open(url_shared_facebook + url_product);
      });
    },

    photoMain: function () {
      if ($('.e-product__photos--large .e-product-photo').length > 1) {

        $('.e-product__photos--large').slick({
          slidesToShow: 1,
          autoplay: false,
          infinite: false,
          fade: false,
          dots: false,
          arrows: true,
          responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
              arrows: false
            }
          }, ]
        });

        $(document).on('click', '.e-product__photos--thumbs .e-product-photo', function (e) {
          var slideIndex = $(this).index();
          $('.e-product__photos--large').slick('slickGoTo', slideIndex);
        });

      }
    },

    tagsProductMobile: function () {
      if ($(window).width() < 1007) {
        $('.e-product__photos').prepend($('.e-product__infos--tags'));
      }
    },

    photoMainFixed: function () {
      if ($(window).width() > 1007) {
        let calc = ($('html, body').scrollTop() + window.innerHeight) - ($('.e-product__photos--wrapper').offset().top + $('.e-product__photos--wrapper').height());
        let timeOut = null
        $('.e-features__tabs li, .e-features__content .e-title, .howToUse__list li .title').click(() => {
          setInterval(() => {
            $('.e-product__photos--wrapper').removeClass('e-scroll-absolute')
            var o = $('html, body').scrollTop();
            if (((o + window.innerHeight) - calc) <= ($('.e-product__photos--container').offset().top + $('.e-product__photos--container').height())) {
              $('.e-product__photos--wrapper').removeClass('e-scroll-absolute');
            } else {
              $('.e-product__photos--wrapper').addClass('e-scroll-absolute');
            }
          }, 100)
        })

        $(document).scroll(function () {
          var o = $('html, body').scrollTop();
          if (((o + window.innerHeight) - calc) <= ($('.e-product__photos--container').offset().top + $('.e-product__photos--container').height())) {
            $('.e-product__photos--wrapper').removeClass('e-scroll-absolute');
          } else {
            $('.e-product__photos--wrapper').addClass('e-scroll-absolute');
          }
        });

      }
    },

    getPositionPhotoMainFixed: function () {
      var o = $(document).scrollTop();
      $('#main .e-product').outerHeight(!0, !0) - o - $('.e-product__photos--wrapper').outerHeight(!0, !0) <= 0 ? $('.e-product__photos--wrapper').addClass('e-scroll-absolute') : $('.e-product__photos--wrapper').removeClass('e-scroll-absolute');
    },

    descriptionShort: function () {
      var descriptionShort = $('.e-product-description-fake .e-descricao-curta').html();
      $('.e-product__infos--description-short').html(descriptionShort);
    },

    selectorQuantity: function () {
      var _more = $('.e-selector-qtda__plus');
      var _minus = $('.e-selector-qtda__minus');

      $(_more).click(function () {
        var _element = $(this);
        var _quantity = $(".e-selector-qtda__input");
        var _quantity_ja = $('.ProductForm .ProductForm__Variants input[name="quantity"]');

        _quantity.val(parseInt(_quantity.val()) + 1),
          _quantity_ja.val(parseInt(_quantity_ja.val()) + 1),
          _quantity.change(),
          _quantity_ja.change()
      });

      $(_minus).click(function () {
        var _element = $(this);
        var _quantity = $(".e-selector-qtda__input");
        var _quantity_ja = $('.ProductForm .ProductForm__Variants input[name="quantity"]');

        1 != _quantity.val() && _quantity.val(parseInt(_quantity.val()) - 1),
          1 != _quantity_ja.val() && _quantity_ja.val(parseInt(_quantity_ja.val()) - 1),
          _quantity.change(),
          _quantity_ja.change()
      });
    },

    descriptionAbas: function () {
      var descriptionShort = $('.e-product-description-fake .e-descricao-abas').html();
      $('.e-product__infos--description-accordion').html(descriptionShort);


      var title = $('.e-features__content .e-title');

      title.click(function () {
        $(this).parent().toggleClass('is--active');
      });
    },

    modalHowToUse: function () {
      $(document).on('click', '.e-product-how-to-use a', function (e) {
        e.preventDefault();
        $('.e-modal-how-to-use').addClass('e-active');
        $('body').addClass('e-no-scroll');
      });

      $(document).on('click', '.e-modal-how-to-use__close, .e-modal-how-to-use__overlay', function (e) {
        e.preventDefault();
        $('.e-modal-how-to-use').removeClass('e-active');
        $('body').removeClass('e-no-scroll');
      });
    },

    addToCart: function () {
      $(document).on('click', '.js--add-to-cart', (ev) => {
        // disable button buy
        $(this).attr('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent("theme:loading:start"))

        // get value variant product id
        var variation_id = $('.js--id-product').val();

        var qtda_product = $('.e-selector-qtda__input').val();
        var max_product_items = $('.e-selector-qtda__input').data('maxlimit');

        // ADD TO CART
        let product = {
          quantity: qtda_product,
          id: variation_id
        }

        if (qtda_product > max_product_items) {
          var _html = '<span class="ProductForm__Error Alert Alert--error">O estoque disponível desse produto é de: ' + max_product_items + '<br/> Você não pode adicionar uma quantidade maior que essa ao carrinho.' + '</span>';
          var _parent = $('.e-btn-add-to-cart .ProductForm__Error')

          $('.e-btn-add-to-cart').append(_html)
          setTimeout(function () {
            $('.e-btn-add-to-cart .ProductForm__Error').remove();
          }, 7000)

        } else {
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: product,
            success: function (response) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"))
              document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: response,
                  quantity: parseInt(qtda_product)
                }
              }))
            },
            error: function (response) {
              var _html = '<span class="ProductForm__Error Alert Alert--error">' + response.responseJSON.description + '</span>';
              var _parent = $('.e-btn-add-to-cart .ProductForm__Error')
              if (_parent.length == 0) {
                $('.e-btn-add-to-cart').append(_html)
                setTimeout(function () {
                  $('.e-btn-add-to-cart .ProductForm__Error').remove();
                }, 7000)
              }
            }
          });
        }

        // enable button buy
        $(this).removeAttr('disabled');
      });
    },
      
    addToCartAndRedirect: function () {
      $(document).on('click', '.ProductForm__AddToCart', (ev) => {
        // disable button buy
        $(this).attr('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent("theme:loading:start"))

        // get value variant product id
        var variation_id = $('.js--id-product').val();

        var qtda_product = $('.e-selector-qtda__input').val();
        var max_product_items = $('.e-selector-qtda__input').data('maxlimit');

        // ADD TO CART
        let product = {
          quantity: qtda_product,
          id: variation_id
        }

        if (qtda_product > max_product_items) {
          var _html = '<span class="ProductForm__Error Alert Alert--error">O estoque disponível desse produto é de: ' + max_product_items + '<br/> Você não pode adicionar uma quantidade maior que essa ao carrinho.' + '</span>';
          var _parent = $('.e-btn-add-to-cart .ProductForm__Error')

          $('.e-btn-add-to-cart').append(_html)
          setTimeout(function () {
            $('.e-btn-add-to-cart .ProductForm__Error').remove();
          }, 7000)

        } else {
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: product,
            success: function (response) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"))
              window.location.href = '/cart';
            },
            error: function (response) {
              var _html = '<span class="ProductForm__Error Alert Alert--error">' + response.responseJSON.description + '</span>';
              var _parent = $('.e-btn-add-to-cart .ProductForm__Error')
              if (_parent.length == 0) {
                $('.e-btn-add-to-cart').append(_html)
                setTimeout(function () {
                  $('.e-btn-add-to-cart .ProductForm__Error').remove();
                }, 7000)
              }
            }
          });
        }

        // enable button buy
        $(this).removeAttr('disabled');
      });
    },

    /* addReviewsTags: function () {
      setTimeout(function () {
        if ($('.spr-summary-actions-togglereviews').length) {
          var title_review = $('.spr-summary-actions-togglereviews').text().split(' ')[2]; // get number reviews

          if (title_review != undefined) {

            $('.e-product__infos--name-product').before('\
                        <a href="#" class="e-title-reviews">' + title_review + ' avaliações</a>\
                        ');
          }
        }
      }, 3000);

      $(document).on('click', '.e-title-reviews', function (e) {
        e.preventDefault();

        $('html, body').animate({
          scrollTop: $('.e-product-reviews').offset().top - 80
        }, 'slow');
      });
    }, */
  
  	addPricePercent: function(){
		var discountPercent = $('.e-discount-all-store').val();
      	
      	// se tiver valor cadastrado no campo Desconto em Toda Loja, atribui desconto nos produtos
      	if(discountPercent > 0){
          	setTimeout(function(){
				$('.ProductItem').each(function(){
                    var priceCalc	  = 0;
                  	var priceValue    = 0;

                    var priceReal     = $(this).find('.ProductItem__PriceList .ProductItem__Price.e-price-item').text();
                    var priceFormat   = $(this).find('.ProductItem__PriceList .ProductItem__Price.e-price-item').text().split("R$ ")[1].replace(".", "").replace(",", ".");

                    priceCalc  = parseFloat(priceFormat - (priceFormat * discountPercent / 100)); // calculo preço
          			priceValue = ((Math.ceil(priceCalc*100))/100); // arredondamento do preço
					
                  	$(this).find('.ProductItem__PriceList .ProductItem__Price').remove();
                    $(this).find('.ProductItem__PriceList').prepend('<div class="ProductItem__PriceList  Heading"><span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + priceReal + '</span><span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible=""> R$ ' + DiscountAllStore.formatMoney(priceValue) + '</span></div>');
                });
            }, 2000);
        }
  	},
      
    calcPercent: function () {
      	var discountPercent = $('.e-discount-all-store').val();
      
      	if(discountPercent > 0){
          
            var priceCalc	  = 0;
          	var priceValue    = 0;

            var priceReal     = $('.e-product-prices .e-product-prices__best-price').text();
            var priceFormat   = $('.e-product-prices .e-product-prices__best-price').text().split("R$ ")[1].replace(".", "").replace(",", ".");

            priceCalc  = parseFloat(priceFormat - (priceFormat * discountPercent / 100)); // calculo preço
          	priceValue = ((Math.ceil(priceCalc*100))/100); // arredondamento do preço
          
            $('.e-product__infos--group-prices .e-product-prices').html('<span class="e-product-prices__old-price">' + priceReal + '</span><span class="e-product-prices__best-price"> R$ ' + DiscountAllStore.formatMoney(priceValue) + '</span> <span class="e-product-prices__best-price-percent">('+ discountPercent +'% OFF)</span>');

          
        } else {
      
            if($('.e-product-prices__old-price').length){
                try {
                  var _oldPrice = $('.e-product-prices__old-price');
                  var _oldPriceText = Number(_oldPrice.text().trim().split('R$ ')[1].replace(',', '.'))

                  var _bestPrice = $('.e-product-prices__best-price');
                  var _bestPriceText = Number(_bestPrice.text().trim().split('R$ ')[1].replace(',', '.'))

                  var _percentTotal = (_bestPriceText * 100) / _oldPriceText
                  var _porcent = 100 - _percentTotal;
                  $('.e-product-prices').append('<span class="e-product-prices__best-price-percent" >(' + _porcent.toFixed(0) + '% OFF)</span>')
                } catch (err) {
                  // console.log('sem porcentagem')
                }
            }
          
        }
    },
      
    howToUse: function () {
      if ($('.howToUse').length && !$('.e-features').next().hasClass('howToUse')) {
        $('.e-features').after($('.howToUse'));

        $('ul.howToUse__list li.howToUse__list__item span.title').click(function (e) {
          let target = $(this);
          setTimeout(() => {
            target.parent().toggleClass('is--active');
          }, 200)
        })
      }
    },
      
    textGarrafas: function () {
      if ($('.custom-text').length && !$('.e-product__infos--form-add-to-cart').next().hasClass('custom-text')) {
        $('.e-product__infos--form-add-to-cart').after($('.custom-text').clone());
      }
    },
      
    kitCombination: function () {
      if ($('.kit-combination').length && !$('.e-product__infos--name-product').next().hasClass('kit-combination')) {
        $('.e-product__infos--name-product').after($('.kit-combination').clone());
      }
    },
      
    newDescription: function () {
      let description = $('.e-product-description-fake .e-descricao-abas').find('.e-item');

      let liDescription = $('ul.e-features__content li.descricao');
      let liFragrancia = $('ul.e-features__content li.fragrancia');
      let liComposicao = $('ul.e-features__content li.composicao');
      //descricao
      let divItemsDescricao = [];
      description.each((index, element) => {
        let title = $(element).find('h4.e-title').clone();
        let item = $('<div class="item"></div>');

        $(element).find('.e-item-text p').each((index, p) => {

          if (index === 0) {
            item.append(title).append($(p).clone());

          }
          if ($(p).find('strong').length && !$(p).find('strong').text().toLowerCase().includes('fragrância') && !$(p).find('strong').text().toLowerCase().includes('composição')) {
            item.append($(p).clone());
          }
        })
        if ($(element).find('.e-item-text p').length) {
          divItemsDescricao.push(item)
        }

      })
      divItemsDescricao.forEach((element, index) => {
        liDescription.append(element);
      })


      //fragancia
      let divItemsFragancia = [];
      description.each((index, element) => {
        let title = $(element).find('h4.e-title').clone();
        let item = $('<div class="item"></div>');

        $(element).find('.e-item-text p').each((index, p) => {
          if ($(p).find('strong').length && $(p).find('strong').text().toLowerCase().includes('fragrância')) {
            item.append(title).append($(p).clone());
          }
        })
        if ($(element).find('.e-item-text p').length && item.children().length) {
          divItemsFragancia.push(item)
        }
      })
      divItemsFragancia.forEach((element, index) => {
        liFragrancia.append(element);
      })
      //composicao
      let divItemsComposicao = [];
      description.each((index, element) => {
        let title = $(element).find('h4.e-title').clone();
        let item = $('<div class="item"></div>');

        $(element).find('.e-item-text p').each((index, p) => {
          if ($(p).find('strong').length && $(p).find('strong').text().toLowerCase().includes('composição')) {
            item.append(title).append($(p).clone());
          }
        })
        if ($(element).find('.e-item-text p').length && item.children().length) {
          divItemsComposicao.push(item)
        }

      })
      divItemsComposicao.forEach((element, index) => {
        liComposicao.append(element);
      });

      $('.e-features__tabs li').click(function () {
        $('.e-features__tabs li').removeClass('js--active');
        $(this).addClass('js--active');

      })
      if (!$('.e-features__content li .item').length) {
        $('.e-product__infos--group .e-features').attr('style', 'display: none')
      }
      if ($('.e-features__content li.descricao .item').length) {
        $($('.e-features__tabs .descricao').attr('style', 'display: block'));
      } else {
        $($('.e-features__tabs .descricao').attr('style', 'display: none'));
      }
      if ($('.e-features__content li.composicao .item').length) {
        $($('.e-features__tabs .composicao').attr('style', 'display: block'));
      } else {
        $($('.e-features__tabs .composicao').attr('style', 'display: none'));
      }
      if ($('.e-features__content li.fragrancia .item').length) {
        $($('.e-features__tabs .fragrancia').attr('style', 'display: block'));
      } else {
        $($('.e-features__tabs .fragrancia').attr('style', 'display: none'));
      }
      $('.e-features__content > li:first-child').addClass('is--active');
      $(document).on('click', '.e-features__tabs li', function () {
        $('.e-features__content >li').removeClass('is--active');
        if ($(this).hasClass('descricao')) {
          $('.e-features__tabs--line').attr('style', 'left: 0');
          $('.e-features__content > li.descricao').addClass('is--active');
        }
        if ($(this).hasClass('fragrancia')) {
          $('.e-features__content > li.fragrancia').addClass('is--active');
          $('.e-features__tabs--line').attr('style', 'left: 33.33%');
        }
        if ($(this).hasClass('composicao')) {
          $('.e-features__content > li.composicao').addClass('is--active');
          $('.e-features__tabs--line').attr('style', 'left: 66.66%');
        }
      });
      $('.e-features__content li .item:first-child').addClass('is--active');


      $('.e-features__content > li').each(function () {
        let verify = () => {
          let haveChild = false;
          $(this).find('.item').each((index, element) => {
            if (!$(element).children().length) {
              haveChild = false;
            } else {
              haveChild = true;
            }
          });
          return haveChild;
        }

        if (verify() === false) {
          $('.e-features__tabs > li.' + $(this).attr('class').replace('is--active', '').trim()).attr('style', 'display: none');
        }
      })
    },
      
    selectColorSize: function () {
      try {
        if ($('.ProductForm__Item').length > 0) {
          this.addToCartColorSize();
          var _type = $('.ProductForm__Item').data('spec');
          var _specs = $('.no-js.ProductForm__Option');

          _specs.find('select option').each(function (index, item) {
            var label = _type + ': ' + $(item).text().split(' -')[0];
            $(item).text(label)
          });

          $('.ProductForm__Option').html(_specs.html());

          $(document).on('change', '.ProductForm__Option select', function () {

            var _val = $(this).find('option:selected').attr('value')
            $('.js--id-product').val(_val)

          });
        }
      } catch (err) {
        // console.log(err)
      }
    },
      
    addToCartColorSize: function () {
      $(document).on('click', '.ProductForm__AddToCart', (ev) => {
        ev.preventDefault();
        // disable button buy
        $(this).attr('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        // get value variant product id
        var variation_id = $('.js--id-product').val();

        var qtda_product = $('.e-selector-qtda__input').val();
        var max_product_items = $('.e-selector-qtda__input').data('maxlimit');

        // ADD TO CART
        let product = {
          quantity: qtda_product,
          id: variation_id
        }

        if (qtda_product > max_product_items) {
          var _html = '<span class="ProductForm__Error Alert Alert--error">O estoque disponível desse produto é de: ' + max_product_items + '<br/> Você não pode adicionar uma quantidade maior que essa ao carrinho.' + '</span>';
          var _parent = $('.e-btn-add-to-cart .ProductForm__Error')

          $('.e-btn-add-to-cart').append(_html)
          setTimeout(function () {
            $('.e-btn-add-to-cart .ProductForm__Error').remove();
          }, 7000)

        } else {
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: product,
            success: function (response) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"))
              window.location.href = "/cart";
            },
            error: function (response) {
              var _html = '<span class="ProductForm__Error Alert Alert--error">' + response.responseJSON.description + '</span>';
              var _parent = $('.e-btn-add-to-cart .ProductForm__Error')
              if (_parent.length == 0) {
                $('.e-btn-add-to-cart').append(_html)
                setTimeout(function () {
                  $('.e-btn-add-to-cart .ProductForm__Error').remove();
                }, 7000)
              }
            }
          });
        }

        // enable button buy
        $(this).removeAttr('disabled');
      });
    },
      
    btnRateScroll: function () {
      $(document).on('click', '.spr-summary-actions a', function () {
        if ($('.spr-form').is(':visible')) {
          $('html, body').animate({
            scrollTop: $('.spr-form').offset().top - 100
          }, 1000);
        }
      })
    },

    verifyIfIsGiftCard: function(){
      if(window.location.href.includes('gift-card-b-o-b')){
       $(".colorThumbs span").text("Valores")
       
      setTimeout(()=>{
        $('.e-product-prices__best-price').text($('.thumb.e-gift.active').text())
      },500)
      
      }
    },
      
    init: function () {
      this.newDescription();
      this.howToUse();
      this.kitCombination();
      this.textGarrafas();
      this.selectColorSize();
      this.addPricePercent();
      this.calcPercent();
      this.verifyIfIsGiftCard()
      this.socialMedia();
      this.photoMain();
      this.tagsProductMobile();
      this.photoMainFixed();
      this.descriptionShort();
      this.selectorQuantity();
      this.descriptionAbas();
      this.modalHowToUse();
      this.addToCart();
      this.addToCartAndRedirect();
      // this.addReviewsTags();
      this.btnRateScroll();
      this.howToUseDinamic();
      // this.fixProductName();
      // $('.e-product__infos--name-product').text($('.e-product__infos--name-product').text().toLowerCase())
    },

  },

  mounted: function () {
    return this.methods.init();
  },
};

$(document).ready(function () {
  ProductMain.mounted();
  productShopify.variants.forEach((variant, index) => {
    if ($('.product-form__variants.no-js option[selected]').val() == variant.id) {
      $('.e-product__infos--form-add-to-cart input').val(variant.id)
      
      if(window.location.href.includes('gift-card-b-o-b')){
        $('ul.colorThumbs').append(`
        <li class="thumb e-gift active" data-id="${variant.id}">
           ${variant.title}
        </li>
    `)
      }
      else{
         $('ul.colorThumbs').append(`
        <li class="thumb active" data-id="${variant.id}">
            <img src="https://cdn.shopify.com/s/files/1/0065/1277/1170/files/thumb-cor-${variant.title}.jpg" alt="${variant.title}">
        </li>
    `)
    }

     
    } else {
      
        if(window.location.href.includes('gift-card-b-o-b')){
        $('ul.colorThumbs').append(`
        <li class="thumb e-gift" data-id="${variant.id}">
           ${variant.title}
        </li>
    `)
      }
      else{
        
      $('ul.colorThumbs').append(`
        <li class="thumb" data-id="${variant.id}">
            <img src="https://cdn.shopify.com/s/files/1/0065/1277/1170/files/thumb-cor-${variant.title}.jpg" alt="${variant.title}">
        </li>
    `)
      }
    }

  })
  $('ul.colorThumbs > li.thumb').click(function () {
    let id = $(this).attr('data-id');

    if (window.location.search.match(/&variant=\d\d\d\d\d\d\d\d\d\d\d\d\d\d/g)) {
      window.location.search = window.location.search.replace(/&variant=\d\d\d\d\d\d\d\d\d\d\d\d\d\d/g, '&variant=' + id)
    } else {
      window.location.search = window.location.search + '&variant=' + id
    }

  })
});
